(function () {
  if (window.customElements && customElements.get('sale-live-feed')) return;

  /** Fisher-Yates, in place. */
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function lines(raw) {
    return String(raw || '')
      .split('\n')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  class SaleLiveFeed extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      var d = this.dataset;

      // The reveal and the video run first and independently — they still have
      // to work when the purchase feed is off or has no names to draw from.
      this.video = this.querySelector('[data-shl-video]');
      this.arm(d.animate === 'true');
      this.setupVideo();

      this.buyerEl = this.querySelectorAll('[data-shl-buyer]');
      this.agoEl = this.querySelectorAll('[data-shl-ago]');
      this.tickers = this.querySelectorAll('[data-shl-ticker]');
      if (!this.buyerEl.length) return;

      this.names = lines(d.names);
      this.cities = lines(d.cities);
      if (!this.names.length || !this.cities.length) return;

      this.lineTpl = d.lineTemplate || '[name] from [city] just bought it';
      this.agoTpl = d.agoTemplate || '[n] min ago';
      this.agoMin = parseInt(d.agoMin, 10) || 2;
      this.agoMax = parseInt(d.agoMax, 10) || 10;
      if (this.agoMax < this.agoMin) this.agoMax = this.agoMin;
      this.poolSize = parseInt(d.poolSize, 10) || 100;
      this.interval = parseInt(d.rotateMs, 10) || 4500;
      this.stateKey = 'shl-last-' + (d.sectionId || 'feed');

      this.pool = this.buildPool();
      if (!this.pool.length) return;

      // Don't reopen on the same buyer the visitor saw a moment ago.
      try { this._last = window.sessionStorage.getItem(this.stateKey) || null; } catch (e) { this._last = null; }

      this.deck = [];
      this.show(this.next(), false);

      var self = this;
      if (this.pool.length > 1 && this.interval > 0) {
        this.timer = setInterval(function () { self.show(self.next(), true); }, this.interval);
      }

      // Pause while the tab is hidden so the feed doesn't burn through the deck unseen.
      this._onVis = function () {
        if (document.hidden) {
          clearInterval(self.timer); self.timer = null;
        } else if (!self.timer && self.pool.length > 1 && self.interval > 0) {
          self.timer = setInterval(function () { self.show(self.next(), true); }, self.interval);
        }
      };
      document.addEventListener('visibilitychange', this._onVis);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this._onVis);
      this.disarm();

      var self = this;
      if (this._video) {
        ['scroll', 'resize', 'orientationchange', 'pageshow'].forEach(function (e) {
          window.removeEventListener(e, self._video);
        });
        document.removeEventListener('visibilitychange', this._video);
        this._video = null;
      }
    }

    /**
     * Bring the contents back as the section scrolls into view.
     * The hidden state is rendered by the section itself (so there's no flash of
     * un-hidden content before this file loads) and an inline failsafe next to
     * the markup lifts it if this script never arrives.
     */
    arm(on) {
      if (!on) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // In the theme editor the section is re-rendered on every change, often
      // already past the fold — show it straight away rather than sitting blank.
      var editing = window.Shopify && window.Shopify.designMode;

      if (reduced || editing) {
        this.classList.remove('shl--armed');
        this.classList.add('shl--in');   // shine only; nothing stays hidden
        return;
      }

      var self = this;

      // A plain rect test rather than IntersectionObserver. IO is suspended in
      // background and prerendered tabs, which would leave an armed section
      // sitting invisible; measuring on scroll can't get stuck that way.
      this._reveal = function () {
        var r = self.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        if (r.top < h * 0.88 && r.bottom > 0) {
          self.classList.add('shl--in');
          self.disarm();
        }
      };

      this._events = ['scroll', 'resize', 'orientationchange', 'pageshow'];
      this._events.forEach(function (e) {
        window.addEventListener(e, self._reveal, { passive: true });
      });

      this._reveal();                                   // already on screen?
      setTimeout(this._reveal, 250);                    // after fonts/images settle
    }

    disarm() {
      var self = this;
      if (!this._events) return;
      this._events.forEach(function (e) { window.removeEventListener(e, self._reveal); });
      this._events = null;
    }

    /**
     * Play the panel video only while it is actually on screen, and never for
     * visitors who have asked for reduced motion — they keep the poster frame.
     */
    setupVideo() {
      var v = this.video;
      if (!v) return;

      v.muted = true;                 // belt and braces: autoplay is refused otherwise
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduced || !v.autoplay) {
        v.autoplay = false;
        v.removeAttribute('autoplay');
        try { v.pause(); } catch (e) {}
        if (reduced) v.setAttribute('controls', '');   // still watchable, just not on its own
        return;
      }

      var self = this;
      var play = function () {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});      // a refused autoplay is not an error
      };

      this._video = function () {
        var r = self.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        var onScreen = r.bottom > 0 && r.top < h;
        if (onScreen && !document.hidden) {
          if (v.paused) play();
        } else if (!v.paused) {
          v.pause();
        }
      };

      ['scroll', 'resize', 'orientationchange', 'pageshow'].forEach(function (e) {
        window.addEventListener(e, self._video, { passive: true });
      });
      document.addEventListener('visibilitychange', this._video);

      this._video();
    }

    /**
     * Every name x city combination, shuffled, then cut to the pool size.
     * Building from the full cross-product means no pair can ever appear twice,
     * whatever lengths the two lists happen to be.
     */
    buildPool() {
      var combos = [];
      for (var n = 0; n < this.names.length; n++) {
        for (var c = 0; c < this.cities.length; c++) {
          combos.push([this.names[n], this.cities[c]]);
        }
      }
      shuffle(combos);
      combos = combos.slice(0, Math.min(this.poolSize, combos.length));

      var span = this.agoMax - this.agoMin + 1;
      var self = this;
      return combos.map(function (pair, i) {
        return {
          line: self.lineTpl.replace(/\[name\]/g, pair[0]).replace(/\[city\]/g, pair[1]),
          ago: self.agoTpl.replace(/\[n\]/g, String(self.agoMin + (i % span)))
        };
      });
    }

    /** Deal from a shuffled deck; reshuffle when spent, never repeating across the seam. */
    next() {
      if (!this.deck.length) {
        this.deck = shuffle(this.pool.slice());
        if (this.deck.length > 1 && this._last && this.deck[this.deck.length - 1].line === this._last) {
          var t = this.deck[0];
          this.deck[0] = this.deck[this.deck.length - 1];
          this.deck[this.deck.length - 1] = t;
        }
      }
      var item = this.deck.pop();
      this._last = item.line;
      try { window.sessionStorage.setItem(this.stateKey, item.line); } catch (e) {}
      return item;
    }

    show(item, animate) {
      if (!item) return;
      this.buyerEl.forEach(function (el) { el.textContent = item.line; });
      this.agoEl.forEach(function (el) { el.textContent = item.ago; });
      if (!animate) return;
      this.tickers.forEach(function (el) {
        el.classList.remove('is-swapping');
        void el.offsetWidth;            // restart the animation
        el.classList.add('is-swapping');
      });
      this.dispatchEvent(new CustomEvent('shl:tick', { bubbles: true, detail: item }));
    }
  }

  customElements.define('sale-live-feed', SaleLiveFeed);
})();
